import { createFileRoute } from "@tanstack/react-router";
import { CreateContainerShell, CreateWorkspaceSetupPage } from "@/features/workspaces";

function CreateWorkspaceLayoutRoute() {
  return (
    <CreateContainerShell
      step={1}
      totalSteps={2}
      title="Create a workspace"
      subtitle="A workspace represents your company or organization. Inside it, you create projects where work happens."
    >
      <CreateWorkspaceSetupPage />
    </CreateContainerShell>
  );
}

export const Route = createFileRoute("/_authenticated/workspaces/create")({
  component: CreateWorkspaceLayoutRoute,
});
